<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p style="text-indent:0em !important;">Special thanks to my literary agent Steven Lloyd for incredible support.</p><br/>
<p style="text-indent:0em !important;">And Sir Christopher Lee for the inspiration of creating what I am today.</p><br/>
<p style="text-indent:0em !important;">And to my photographer, Diane Sutton.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?8a4e02f2